import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { enqueueSnackbar } from "notistack";
import { PostFetch } from "../../../../services/apiBase";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import LoadingComponent from "../../../../components/LoadingComponent";

export default function NewPolModal({
  open,
  onClose,
  getList,
  table,
  lastIpcaFactor,
}) {
  const user = JSON.parse(localStorage.getItem("user"));

  const [load, setLoad] = useState(false);
  const [loadingYear, setLoadingYear] = useState(false);

  const [dateRate, setDateRate] = useState(null);
  const [publishedAt, setPublishedAt] = useState(null);

  const [agreement, setAgreement] = useState({});
  const [currentYear, setCurrentYear] = useState(null);
  const [years, setYears] = useState([]);
  const [yearData, setYearData] = useState({});
  const [yearsToUse, setYearsToUse] = useState(2);

  function addDataToYear(event) {
    const key = event.target.id;
    const value = event.target.value;
    setYearData({ ...yearData, [key]: value });
  }

  const handleOnChange = (e) => {
    const key = e.target.id;
    const value = e.target.value;
    setAgreement({ ...agreement, [key]: value });
  };

  const handleOnCloseModal = () => {
    onClose();
  };

  const addYearsReports = async () => {
    if (years.length < yearsToUse) {
      if (Object.keys(yearData).length === 13 && validateYearDataAttributes()) {
        setLoadingYear(true);
        setYears((previousState) => [...previousState, yearData]);
        setYearData({});
        setPublishedAt(null);
      } else {
        enqueueSnackbar("Complete os campos do formulário.", {
          variant: "info",
        });
      }
    }
  };

  const validateYearDataAttributes = () => {
    for (const key in yearData) {
      if (yearData.hasOwnProperty(key)) {
        const value = yearData[key];
        if (value === "") return false;
      }
    }
    return true;
  };

  const handleSubmitReports = async () => {
    setLoad(true);
    try {
      await PostFetch(`/financial/indicators?indicator=${table}`, {
        years: years,
        username: user.name,
      });
      enqueueSnackbar("Novo indicador cadastrado com sucesso!", {
        variant: "success",
      });
      handleOnCloseModal();
    } catch (error) {
      enqueueSnackbar("Erro ao cadastrar novo indicador!", {
        variant: "error",
      });
    } finally {
      setLoad(false);
    }
  };

  const handleSubmit = async () => {
    setLoad(true);
    try {
      const response = await PostFetch(
        `/financial/indicators?indicator=${table}`,
        { ...agreement, username: user.username }
      );
      enqueueSnackbar("Novo indicador cadastrado com sucesso!", {
        variant: "success",
      });
      handleOnCloseModal();
      getList();
    } catch (error) {
      enqueueSnackbar("Erro ao cadastrar novo indicador!", {
        variant: "error",
      });
      handleOnCloseModal();
    } finally {
      setLoad(false);
    }
  };

  function handleChangeDate(value) {
    let data = new Date(value);
    data = moment.utc(data).format("YYYY-MM-DD");
    if (table === "REPORTS") {
      setYearData({ ...yearData, published_at: data });
      setPublishedAt(value);
    } else {
      setDateRate(value);
      setAgreement({ ...agreement, date_rate: data });
    }
  }

  function handleSetType(value) {
    if (value === "ATUAL") {
      agreement.financial_indicator_id = 6;
    } else {
      agreement.financial_indicator_id = 7;
    }
  }

  function handleSetFactor() {
    // console.log('---------handleSetFactor')
    // console.log({lastIpcaFactor})
    // console.log({rate: agreement.value_rate})

    if (lastIpcaFactor > 0) {
      agreement.factor = ((1 + Number(agreement.value_rate)) * Number(lastIpcaFactor)).toFixed(6);
    } else {
      agreement.factor = 0;
    }
    // console.log({ agreement });
  }

  useEffect(() => {
    if (currentYear === null) {
      const date = new Date();
      setCurrentYear(date.getFullYear());
    }
  }, []);

  useEffect(() => {
    if (table === "CDI_FUTURO") {
      setAgreement({ ...agreement, financial_indicator_id: 8 });
    }
  }, [agreement]);

  useEffect(() => {
    handleSetFactor();
  }, [agreement.value_rate, yearData.value_rate]);

  useEffect(() => {
    setLoadingYear(false);
    if (years.length === yearsToUse) {
      handleSubmitReports();
    }
  }, [years]);

  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        boxShadow: 24,
        borderRadius: 2,
        backgroundColor: grey[300],
      }}
    >
      <Box
        sx={{
          padding: "16px",
          borderRadius: "8px 8px 0 0",
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="h6" component="h2">
          {load
            ? "Cadastrando novo indicador"
            : `Cadastrar novo indicador ${currentYear + years.length}`}
        </Typography>
      </Box>

      <Box
        sx={{
          marginTop: "16px",
          marginBottom: "16px",
          marginRight: "32px",
          width: 400,
          minWidth: 400,
          maxHeight: "80%",
          height: "90%",
          width: "100%",
          backgroundColor: "#fff",
          borderRadius: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: 1,
            gap: 2,
          }}
        >
          {table !== "REPORTS" ? (
            <>
              <FormControl fullWidth>
                <DatePicker
                  id={`date_rate`}
                  label="Date Rate"
                  type="date"
                  value={dateRate}
                  format="DD/MM/YYYY"
                  onChange={(event) => {
                    handleChangeDate(event);
                  }}
                />
              </FormControl>

              <FormControl fullWidth>
                <InputLabel id="value_rate">Taxa</InputLabel>
                <OutlinedInput
                  id={`value_rate`}
                  endAdornment={
                    <InputAdornment position="end">%</InputAdornment>
                  }
                  label="Taxa"
                  value={agreement.value_rate}
                  onChange={(event) => {
                    handleOnChange(event);
                  }}
                />
              </FormControl>

              {table === "IPCA_FUTURO" ? (
                <FormControl fullWidth>
                  <InputLabel>Selecione o tipo</InputLabel>
                  <Select
                    id="agreement.type"
                    label="Selecione o tipo"
                    value={agreement.type}
                    onChange={(event) => {
                      handleSetType(event.target.value);
                      setAgreement({
                        ...agreement,
                        ["type"]: event.target.value,
                      });
                    }}
                  >
                    <MenuItem value={"ATUAL"}>Atual</MenuItem>
                    <MenuItem value={"FUTURO"}>Futuro</MenuItem>
                  </Select>
                </FormControl>
              ) : null}
            </>
          ) : (
            <>
              {loadingYear || load ? (
                <Box
                  sx={{
                    width: "40em",
                    minWidth: "40em",
                    maxHeight: "80%",
                    height: "90%",
                    minHeight: "20em",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <LoadingComponent />
                </Box>
              ) : (
                <>
                  <FormControl fullWidth>
                    <DatePicker
                      id={`published_at`}
                      label="Publicado"
                      type="date"
                      value={publishedAt}
                      format="DD/MM/YYYY"
                      onChange={(event) => {
                        handleChangeDate(event);
                      }}
                    />
                  </FormControl>

                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="ipca_four_weeks">IPCA 4W</InputLabel>
                      <OutlinedInput
                        id={`ipca_four_weeks`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="IPCA 4W"
                        value={yearData.ipca_four_weeks}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="ipca_one_week">IPCA 1W</InputLabel>
                      <OutlinedInput
                        id={`ipca_one_week`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="IPCA 1W"
                        value={yearData.ipca_one_week}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="ipca_today">IPCA Hoje</InputLabel>
                      <OutlinedInput
                        id={`ipca_today`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="IPCA Hoje"
                        value={yearData.ipca_today}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="selic_four_weeks">SELIC 4W</InputLabel>
                      <OutlinedInput
                        id={`selic_four_weeks`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="SELIC 4W"
                        value={yearData.selic_four_weeks}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="SELIC_one_week">SELIC 1W</InputLabel>
                      <OutlinedInput
                        id={`selic_one_week`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="SELIC 1W"
                        value={yearData.selic_one_week}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="selic_today">SELIC Hoje</InputLabel>
                      <OutlinedInput
                        id={`selic_today`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="SELIC Hoje"
                        value={yearData.selic_today}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="exchange_rate_brlusd_four_weeks">
                        Câmbio USD 4W
                      </InputLabel>
                      <OutlinedInput
                        id={`exchange_rate_brlusd_four_weeks`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="Câmbio USD 4W"
                        value={yearData.exchange_rate_brlusd_four_weeks}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="exchange_rate_brlusd_one_week">
                        Câmbio USD 1W
                      </InputLabel>
                      <OutlinedInput
                        id={`exchange_rate_brlusd_one_week`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="Câmbio USD 1W"
                        value={yearData.exchange_rate_brlusd_one_week}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="exchange_rate_brlusd_today">
                        Câmbio USD Hoje
                      </InputLabel>
                      <OutlinedInput
                        id={`exchange_rate_brlusd_today`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="Câmbio USD Hoje"
                        value={yearData.exchange_rate_brlusd_today}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="gdp_four_weeks">GDP 4W</InputLabel>
                      <OutlinedInput
                        id={`gdp_four_weeks`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="GDP 4W"
                        value={yearData.gdp_four_weeks}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="gdp_one_week">GDP 1W</InputLabel>
                      <OutlinedInput
                        id={`gdp_one_week`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="GDP 1W"
                        value={yearData.gdp_one_week}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                    <FormControl fullWidth>
                      <InputLabel id="gdp_today">GDP Hoje</InputLabel>
                      <OutlinedInput
                        id={`gdp_today`}
                        endAdornment={
                          <InputAdornment position="end">%</InputAdornment>
                        }
                        label="GDP Hoje"
                        value={yearData.gdp_today}
                        onChange={(event) => {
                          addDataToYear(event);
                        }}
                      />
                    </FormControl>
                  </Box>
                </>
              )}
            </>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "flex-end",
          gap: 1,
          padding: 2,
          borderRadius: "0 0 8px 8px",
          backgroundColor: "#fff",
        }}
      >
        <Button
          variant="contained"
          color={"success"}
          disabled={load || loadingYear}
        >
          <Typography
            color={"#fff"}
            onClick={() => {
              table === "REPORTS" ? addYearsReports() : handleSubmit();
            }}
          >
            {table === "REPORTS" ? (
              <>{years.length < yearsToUse - 1 ? "Continuar" : "Cadastrar"}</>
            ) : (
              <>Cadastrar</>
            )}
          </Typography>
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => {
            onClose();
          }}
        >
          <Typography color={"#fff"}>Fechar</Typography>
        </Button>
      </Box>
    </Box>
  );
}
